export const gridLines = 5;
export const yAxisWidth = 175;
